import axios from 'axios'

const instance = axios.create()
const csrfToken = document.getElementsByName('csrf-token')
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
instance.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.length ? csrfToken[0].content : ''
instance.defaults.withCredentials = true;
instance.defaults.withXSRFToken = true;


// instance.defaults.headers.common['Authorization'] = `Bearer ${window.config.token}`;
instance.interceptors.response.use( response => response, error => {

    const {status} = error.response

    // Show the user a 500 error
    if (status >= 500) {
        console.error('error', error.response.data.message)
        // App.bus.$emit('error', error.response.data.message)
    }

    // Handle Session Timeouts
    if (status === 401) {
        // window.location.href = '/'
    }

    // Handle Forbidden
    if (status === 403) {
        // router.push({ name: '403' })
    }

    // Handle Token Timeouts
    if (status === 419) {
        // App.bus.$emit('token-expired')
    }

    return Promise.reject(error)
})

export default instance